module.exports = __webpack_public_path__ + "15e59c133615d006baa3d0006559c5c5.svg";